export const AUTO_UPGRADE_AWARENESS_SOURCE = 'autoUpgradeAwareness';

// AUA modal
export const AUTO_UPGRADE_AWARENESS_MODAL_SOURCE = 'autoUpgradeAwarenessModal';
export const AUTO_UPGRADE_AWARENESS_MODAL_TEST_ID = 'auto-upgrade-awareness-modal';

// AUA modal storage component
export const AUTO_UPGRADE_AWARENESS_STORAGE_USAGE_COMPONENT = 'autoUpgradeAwarenessStorageUsage';
